(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_request/bet.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_request/bet.js');
'use strict';

class Bet {
  constructor(_ref) {
    let productId = _ref.productId,
      drawNum = _ref.drawNum,
      numDraws = _ref.numDraws,
      betProperties = _ref.betProperties,
      betAmountSalesGroup1 = _ref.betAmountSalesGroup1,
      betAmountSalesGroup2 = _ref.betAmountSalesGroup2,
      rowPriceMulti = _ref.rowPriceMulti,
      jokerBoards = _ref.jokerBoards,
      lottoBoards = _ref.lottoBoards,
      kenoBoards = _ref.kenoBoards,
      numberboards = _ref.numberboards,
      extNumberBoards = _ref.extNumberBoards,
      erNumberBoardData = _ref.erNumberBoardData;
    this.productId = productId;
    this.drawNum = drawNum;
    this.numDraws = numDraws;
    this.betProperties = betProperties;
    this.betAmountSalesGroup1 = betAmountSalesGroup1;
    if (betAmountSalesGroup2) {
      this.betAmountSalesGroup2 = betAmountSalesGroup2;
    }
    if (rowPriceMulti) {
      this.rowPriceMulti = rowPriceMulti;
    }
    if (jokerBoards) {
      this.jokerBoards = jokerBoards;
    }
    if (lottoBoards) {
      this.lottoBoards = lottoBoards;
    }
    if (kenoBoards) {
      this.kenoBoards = kenoBoards;
    }
    if (numberboards) {
      this.numberboards = numberboards;
    }
    if (extNumberBoards) {
      this.extNumberBoards = extNumberBoards;
    }
    if (erNumberBoardData) {
      this.erNumberBoardData = erNumberBoardData;
    }
  }
}
svs.tur.payment.api.jupiter.request.Bet = Bet;

 })(window);